import { render, staticRenderFns } from "./feereturn-details.vue?vue&type=template&id=809a52ea&scoped=true&"
import script from "./feereturn-details.vue?vue&type=script&lang=js&"
export * from "./feereturn-details.vue?vue&type=script&lang=js&"
import style0 from "./feereturn-details.vue?vue&type=style&index=0&id=809a52ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809a52ea",
  null
  
)

export default component.exports